import React from 'react';
import './pagestyles/Tech.css';
import BottomBanner from './BottomBanner';

const Tech = () => {
  return (
      <>
    <div className="page-container">
      <div className="page-header">
        <h1>Technology</h1>
        <p className="page-subtitle">Breaking tech news, AI, cybersecurity, and innovation</p>
      </div>
      
      <div className="page-content">
        <div className="content-grid">
          <a href="/article/ai-revolution-transforms-industries" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop" alt="AI technology" />
            </div>
            <div className="article-content">
              
              <h2>AI Revolution Transforms Industries</h2>
              <p>Artificial intelligence adoption accelerates across sectors, driving unprecedented productivity gains.</p>
              <span className="article-meta">30 minutes ago</span>
            </div>
          </a>

          <a href="/article/cybersecurity-threats-emerge" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop" alt="Cybersecurity" />
            </div>
            <div className="article-content">
              
              <h2>New Security Threats Emerge</h2>
              <p>Cybersecurity experts warn of sophisticated attacks targeting critical infrastructure and enterprises.</p>
              <span className="article-meta">2 hours ago</span>
            </div>
          </a>

          <a href="/article/quantum-computing-breakthrough" className="article-card" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="article-image">
              <img src="https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&h=400&fit=crop" alt="Tech innovation" />
            </div>
            <div className="article-content">
             
              <h2>Quantum Computing Breakthrough</h2>
              <p>Researchers achieve major milestone in quantum computing, bringing practical applications closer to reality.</p>
              <span className="article-meta">4 hours ago</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    
      <BottomBanner />
        </>
  );
};

export default Tech;
